module.exports = __webpack_public_path__ + "img/news1.a373f744.png";